export default __webpack_public_path__ + "static/media/Large-Bread-6.41ed3f7b.jpg";